'use strict';

angular.module('app.advertiserPreferredList')

.directive('advertiserPreferredListDirective', function () {
        return {
            controller: 'advertiserPreferredListCtrl',
            templateUrl: 'app/sideBarMenu/advertiserPreferredList/advertiserPreferredList.html?app_v=deployDate',
            scope: {}    
        };
})